import { ErrorMessage, Field } from "formik";
import Label from "./Label";
import Container from "./Container";
import { Message } from "primereact/message";
import { useReducer } from "react";
import Text from "./Text";
import { InputText } from "primereact/inputtext";

interface IInputProps {
    label: string;
    id: string;
    type?: string;
    children?: React.ReactNode;
    hasError?: boolean;
    error?: string;
    secureText?: boolean;
    value?: string;
    setValue?: (value: string) => void;
    withoutFormikContext?: boolean;
    action?: React.ReactNode;
    required?: boolean;
}

interface IFormFieldState {
    isSecure: boolean;
    type?: string;
    icon: string;
}

const reducer = (state: IFormFieldState, action: { type: string; }) => {
    switch (action.type) {
        case "ShowText":
            return {
                ...state,
                isSecure: false,
                type: "text",
                icon: "pi-eye-slash"
            };
        case "HideText":
            return {
                ...state,
                isSecure: true,
                type: "password",
                icon: "pi-eye"
            };
        default:
            return {
                ...state
            };
    }
}

export default function FormField({ 
    label, 
    id, 
    type, 
    hasError, 
    error,
    secureText, 
    value,
    setValue, 
    withoutFormikContext, 
    action,
    children,
    required
}: IInputProps) {
    const [state, dispatch] = useReducer(reducer, { type, icon: "pi-eye", isSecure: true });

    return (
        <Container flexColumn fullWidth relative>
            <Container between itemsCenter className="mb-2">
                <Label htmlFor={id}>{label}</Label>

                {action}
            </Container>
            {
                withoutFormikContext && !children
                    ? (
                        <InputText 
                            id={id}
                            name={id}
                            type={type}
                            className={`p-3 ${secureText ? "pr-6" : ""} border-1 border-round ${hasError ? "border-red-400" : "border-gray-400"}`}
                            value={value} 
                            required={required}
                            onChange={(e) => setValue?.(e.target.value)} 
                        />
                    )
                    : !children && (
                        <Field name={id}>
                            {
                                // @ts-expect-error Ignore type any error
                                ({ field, meta }) => (
                                    <Field {...field} type={state.type} id={id} className={`p-3 ${secureText ? "pr-6" : ""} border-1 border-round ${meta.touched && meta.error ? "border-red-400" : "border-gray-400"}`} />
                                )
                            }
                        </Field>
                    )
            }

            {
                children
            }

            {
                required && !value && <Message className="mt-2" severity="warn" text="Preencher campo obrigatório" />
            }

            {
                !withoutFormikContext && !children && (
                    <span className="text-red-500 text-xs mt-2">
                        <ErrorMessage name={id} />
                    </span>
                )   
            }

            {
                hasError
                    ? (<Text className="text-red-500 mt-2" size="xs">{error}</Text>) 
                    : null
            }

            {
                secureText && !children && (
                    <i 
                        className={`pi ${state.icon} absolute right-0 text-xl cursor-pointer text-500`} 
                        onClick={() => {
                            state.isSecure 
                                ? dispatch({ type: "ShowText" }) 
                                : dispatch({ type: "HideText" });
                        }}
                        style={{ top: "2.5rem", marginRight: "1rem" }}
                    ></i>
                )
            }
        </Container>
    )
}